export enum PaymentTypeE {
  EXTERNAL_VOUCHER = 'EXTERNAL_VOUCHER',
  ONLINE = 'ONLINE',
  // pola BANK_TRANSFER, CASH oraz INSTALLMENTS obecne, ale nieużywane
  // BANK_TRANSFER,
  // CASH
  // INSTALLMENTS,
}
